import { useState, useEffect, useCallback } from "react";
import { authFetch } from "../App";
import { toast } from "sonner";
import { ChevronRight } from "lucide-react";

import { ImportList } from "./gaeb/GAEBImportList";
import { LVViewer } from "./gaeb/GAEBLVViewer";
import { ProjectCalculation } from "./gaeb/GAEBProjectCalc";

const API = "/api";

export default function GAEBModule() {
  const [view, setView] = useState("list"); // list, viewer, project
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [importData, setImportData] = useState(null);
  const [projectId, setProjectId] = useState(null);

  const loadImports = useCallback(async () => {
    try {
      const res = await authFetch(`${API}/gaeb/imports`);
      if (res.ok) setImports(await res.json());
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { loadImports(); }, [loadImports]);

  const selectImport = async (id) => {
    const res = await authFetch(`${API}/gaeb/imports/${id}`);
    if (res.ok) {
      const data = await res.json();
      setImportData(data);
      setView("viewer");
    }
  };

  const handleAdopt = (pid) => {
    setProjectId(pid);
    setView("project");
    loadImports();
  };

  const handleAdoptFromList = (pid) => {
    setProjectId(pid);
    setView("project");
  };

  const handleDiscard = async () => {
    if (!importData) return;
    if (!window.confirm("Import verwerfen?")) return;
    await authFetch(`${API}/gaeb/imports/${importData.id}`, { method: "DELETE" });
    toast.success("Import verworfen");
    setView("list");
    loadImports();
  };

  return (
    <div className="max-w-[1400px] mx-auto" data-testid="gaeb-module">
      {/* Breadcrumb */}
      <div className="flex items-center gap-1.5 mb-4 text-xs text-gray-400">
        <button onClick={() => setView("list")} className="hover:text-gray-600">GAEB / Kalkulation</button>
        {view === "viewer" && <><ChevronRight className="w-3 h-3" /><span className="text-gray-600">Viewer</span></>}
        {view === "project" && <><ChevronRight className="w-3 h-3" /><span className="text-gray-600">Kalkulation</span></>}
      </div>

      {view === "list" && (
        <ImportList imports={imports} loading={loading} onSelect={selectImport} onRefresh={loadImports} onAdoptFromList={handleAdoptFromList} />
      )}
      {view === "viewer" && importData && (
        <LVViewer data={importData} onAdopt={handleAdopt} onDiscard={handleDiscard} onBack={() => setView("list")} />
      )}
      {view === "project" && projectId && (
        <ProjectCalculation projectId={projectId} onBack={() => setView("list")} />
      )}
    </div>
  );
}
